import React, {memo} from 'react';
import ReactApexChart from 'react-apexcharts';

// Malý koláč do KPI karty monitoringu: kolik z rekordní měsíční tržby (ATH) už
// má aktuální měsíc splněno. Barva výseku podle toho, jak blízko je měsíc
// rekordu (červená → oranžová → žlutá → zelená), tlumený zbytek = kolik
// do rekordu chybí. Jakmile je rekord překonaný, je koláč celý a jasnější.
// Tooltip je vypnutý schválně – panel má overflow: hidden, tak by se u okraje
// ořízl; detail nese title na obalu karty.
// Tón KPI karty „Měsíc" podle stejných prahů, jako má barva výseku koláče,
// aby karta a koláč ladily (červená → oranžová → žlutá → zelená).
// Bez rekordu (první měsíc provozu) je aktuální měsíc rovnou rekordní = zelená.
export function athToneClass(value, target) {
	const val = Math.max(Number(value) || 0, 0);
	const goal = Math.max(Number(target) || 0, 0);
	if (goal <= 0) return 'home-summary-card--success';
	const pct = (val / goal) * 100;
	if (pct >= 90) return 'home-summary-card--success';
	if (pct >= 75) return 'home-summary-card--caution';
	if (pct >= 50) return 'home-summary-card--warning';
	return 'home-summary-card--danger';
}

function MonitorAthDonut({value = 0, target = 0}) {
	const val = Math.max(Number(value) || 0, 0);
	const goal = Math.max(Number(target) || 0, 0);
	const reached = goal > 0 && val >= goal;

	// Bez rekordu (první měsíc provozu) ukážeme jen prázdnou dráhu.
	const done = goal > 0 ? Math.min(val, goal) : 0;
	const rest = goal > 0 ? Math.max(goal - val, 0) : 1;

	// Barva výseku podle plnění rekordu – prahy drží v souladu s athToneClass.
	const pct = goal > 0 ? (val / goal) * 100 : 0;
	let doneColor;
	if (pct >= 90) doneColor = reached ? '#4cd964' : '#66bb66';
	else if (pct >= 75) doneColor = '#ffcc4d';
	else if (pct >= 50) doneColor = '#ff9f45';
	else doneColor = '#ff6e5c';

	const options = {
		chart: {
			type: 'donut',
			fontFamily: 'inherit',
			background: 'transparent',
			animations: {enabled: false},
			// Sparkline režim odřízne vnitřní okraje – jinak by se do 4rem koláč nevešel.
			sparkline: {enabled: true},
		},
		labels: ['Dosaženo', 'Do rekordu'],
		colors: [doneColor, 'rgba(220, 226, 231, 0.16)'],
		stroke: {width: 0},
		legend: {show: false},
		dataLabels: {enabled: false},
		tooltip: {enabled: false},
		states: {hover: {filter: {type: 'none'}}, active: {filter: {type: 'none'}}},
		plotOptions: {
			pie: {
				expandOnClick: false,
				donut: {
					size: '54%',
					labels: {show: false},
				},
			},
		},
	};

	return <ReactApexChart options={options} series={[done, rest]} type="donut" height="100%" width="100%" />;
}

export default memo(MonitorAthDonut);
